// Controle de acessos por perfil (RBAC) — registro único de telas + níveis.
// Compartilhado entre api e web para não haver divergência de chaves.

export type PermissionLevel = 'none' | 'read' | 'edit'
export type AppRole = 'admin' | 'operator' | 'client' | 'agent'

export type ScreenDef = { key: string; label: string; path: string; group: string }

// Telas do sistema (espelha os itens de navegação). O `key` é a identidade estável
// da tela — o `path` casa com a rota (rotas de detalhe herdam a tela do prefixo).
export const SCREENS: ScreenDef[] = [
  { key: 'dashboard', label: 'Dashboard', path: '/', group: 'Início' },

  { key: 'orders', label: 'Pedidos', path: '/orders', group: 'Operação' },
  { key: 'separacao', label: 'Separação', path: '/separacao-arquivo', group: 'Operação' },
  { key: 'despachar', label: 'Despachar', path: '/despachar', group: 'Operação' },
  { key: 'expedir', label: 'Expedir (scan)', path: '/expedir', group: 'Operação' },
  { key: 'cockpit', label: 'Cockpit', path: '/cockpit', group: 'Operação' },
  { key: 'meus-envios', label: 'Meus envios', path: '/meus-envios', group: 'Operação' },
  { key: 'rastreio-lote', label: 'Rastreio em lote', path: '/rastreio-lote', group: 'Operação' },
  { key: 'outbound', label: 'Ordens manuais', path: '/outbound', group: 'Operação' },

  { key: 'stock', label: 'Saldos', path: '/stock', group: 'Estoque' },
  { key: 'abastecimento', label: 'Abastecimento', path: '/abastecimento', group: 'Estoque' },
  { key: 'posicao-estoque', label: 'Posição diária', path: '/posicao-estoque', group: 'Estoque' },
  { key: 'conf-fracionamento', label: 'Conf. Fracionamento', path: '/conferencia-fracionamento', group: 'Estoque' },
  { key: 'conf-armazem', label: 'Conf. Armazém', path: '/conferencia-armazem', group: 'Estoque' },
  { key: 'packing-list', label: 'Packing list', path: '/packing-list', group: 'Estoque' },
  { key: 'contagem', label: 'Contagem', path: '/contagem-mobile', group: 'Estoque' },
  { key: 'divergencias', label: 'Divergências', path: '/divergencias', group: 'Estoque' },
  { key: 'inbound', label: 'Recebimento', path: '/inbound', group: 'Estoque' },
  { key: 'transfers', label: 'Transferências', path: '/transfers', group: 'Estoque' },
  { key: 'adjustments', label: 'Ajustes', path: '/adjustments', group: 'Estoque' },
  { key: 'movimentacoes', label: 'Movimentações', path: '/movimentacoes', group: 'Estoque' },
  { key: 'defeito', label: 'Defeito', path: '/defeito', group: 'Estoque' },
  { key: 'lots', label: 'Lotes', path: '/lots', group: 'Estoque' },

  { key: 'pallets', label: 'Paletes', path: '/pallets', group: 'Armazém' },
  { key: 'locations', label: 'Localizações', path: '/locations', group: 'Armazém' },
  { key: 'warehouses', label: 'Armazéns', path: '/warehouses', group: 'Armazém' },

  { key: 'industria-materiais', label: 'Materiais', path: '/industria/materiais', group: 'Indústria' },
  { key: 'industria-recebimento', label: 'Recebimento', path: '/industria/recebimento', group: 'Indústria' },
  { key: 'industria-etiquetas', label: 'Etiquetas', path: '/industria/etiquetas', group: 'Indústria' },
  { key: 'industria-fichas', label: 'Fichas técnicas', path: '/industria/fichas', group: 'Indústria' },
  { key: 'industria-ops', label: 'Ordens de produção', path: '/industria/ops', group: 'Indústria' },
  { key: 'industria-simulador', label: 'Dá para produzir?', path: '/industria/simulador', group: 'Indústria' },
  { key: 'industria-apontamento', label: 'Apontamento', path: '/industria/apontamento', group: 'Indústria' },
  { key: 'industria-rastreabilidade', label: 'Rastreabilidade', path: '/industria/rastreabilidade', group: 'Indústria' },
  { key: 'industria-compras', label: 'Compras', path: '/industria/compras', group: 'Indústria' },
  { key: 'industria-fornecedores', label: 'Fornecedores', path: '/industria/fornecedores', group: 'Indústria' },
  { key: 'industria-pagar', label: 'Contas a pagar', path: '/industria/pagar', group: 'Indústria' },
  { key: 'industria-faturamento', label: 'Faturamento da indústria', path: '/industria/faturamento', group: 'Indústria' },
  { key: 'industria-solicitacoes', label: 'Solicitações', path: '/industria/solicitacoes', group: 'Indústria' },
  { key: 'industria-embalagem', label: 'Ficha de embalagem', path: '/industria/embalagem', group: 'Indústria' },
  { key: 'minha-producao', label: 'Minha produção', path: '/minha-producao', group: 'Operação' },

  { key: 'clients', label: 'Clientes', path: '/clients', group: 'Cadastros' },
  { key: 'products', label: 'Produtos', path: '/products', group: 'Cadastros' },
  { key: 'users', label: 'Usuários', path: '/users', group: 'Cadastros' },

  { key: 'billing', label: 'Faturamento', path: '/billing', group: 'Gestão' },
  { key: 'integrations', label: 'Integrações', path: '/integrations', group: 'Gestão' },
  { key: 'auditoria', label: 'Logs', path: '/auditoria', group: 'Gestão' },
  { key: 'permissions', label: 'Controle de acessos', path: '/permissions', group: 'Gestão' },
]

export const ROLES: { key: AppRole; label: string }[] = [
  { key: 'admin', label: 'Admin' },
  { key: 'operator', label: 'Operador' },
  { key: 'agent', label: 'Agente' },
  { key: 'client', label: 'Cliente' },
]

const SCREEN_KEYS = new Set(SCREENS.map((s) => s.key))

// Telas exclusivas de administração (não vão para operador/agente/cliente por padrão).
const ADMIN_ONLY = new Set([
  'contagem', 'locations', 'warehouses', 'users', 'integrations', 'auditoria', 'permissions',
  // Dinheiro da indústria — o §7 do INDUSTRIA.md dá ao operador almoxarifado,
  // recebimento, OP e apontamento, "sem custo e sem pagáveis". Compra, fornecedor
  // e título ficam com o admin. É só o padrão: a matriz de acessos permite
  // liberar para um operador específico quando a operação pedir.
  'industria-compras', 'industria-fornecedores', 'industria-pagar', 'industria-faturamento',
])
// Telas operacionais que o agente executa.
const AGENT_SCREENS = new Set([
  'dashboard', 'orders', 'separacao', 'despachar', 'expedir', 'cockpit', 'rastreio-lote',
  'stock', 'abastecimento', 'conf-fracionamento', 'conf-armazem', 'packing-list', 'inbound', 'pallets',
  // Indústria: o agente recebe, imprime etiqueta e aponta produção; cadastro e
  // decisão de perda, não.
  'industria-recebimento', 'industria-etiquetas', 'industria-apontamento',
])
// Telas que o cliente enxerga (somente leitura por padrão).
// O client do fulfillment e o da indústria não são o mesmo escopo — quem não é
// cliente da indústria simplesmente não tem produção para ver no portal.
const CLIENT_SCREENS = new Set([
  'dashboard', 'meus-envios', 'rastreio-lote', 'stock', 'posicao-estoque', 'minha-producao',
])

/** Nível padrão de uma tela para um perfil — reproduz o comportamento atual do menu,
 *  para que, sem nenhuma configuração salva, nada mude no dia 1. */
export function defaultLevel(role: AppRole, screenKey: string): PermissionLevel {
  if (role === 'admin') return 'edit' // admin sempre total (não é editável)
  if (!SCREEN_KEYS.has(screenKey)) return 'none'
  if (role === 'operator') return ADMIN_ONLY.has(screenKey) ? 'none' : 'edit'
  if (role === 'agent') return AGENT_SCREENS.has(screenKey) ? 'edit' : 'none'
  if (role === 'client') return CLIENT_SCREENS.has(screenKey) ? 'read' : 'none'
  return 'none'
}

/** Mapa efetivo (tela → nível) de um perfil, aplicando overrides salvos sobre os defaults. */
export function effectivePermissions(
  role: AppRole,
  overrides: Record<string, PermissionLevel> = {},
): Record<string, PermissionLevel> {
  const out: Record<string, PermissionLevel> = {}
  for (const s of SCREENS) {
    out[s.key] = role === 'admin' ? 'edit' : overrides[s.key] ?? defaultLevel(role, s.key)
  }
  return out
}

/** Resolve a tela a partir de um pathname (rota de detalhe herda o prefixo mais longo). */
export function screenForPath(pathname: string): ScreenDef | undefined {
  let best: ScreenDef | undefined
  for (const s of SCREENS) {
    if (s.path === '/') {
      if (pathname === '/') best = s
      continue
    }
    if (pathname === s.path || pathname.startsWith(s.path + '/')) {
      if (!best || s.path.length > best.path.length) best = s
    }
  }
  return best
}

export const rank: Record<PermissionLevel, number> = { none: 0, read: 1, edit: 2 }
